// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-pages-markdown-remark-frontmatter-path-tsx" + "-" + "06e9909c4b2a76800fb2" + ".js";
};